module.exports = __webpack_public_path__ + "static/media/roboto-v18-latin-ext_latin-regular.e5d046dd.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/roboto-v18-latin-ext_latin-regular.woff2
// module id = ./src/common/fonts/roboto-v18-latin-ext_latin-regular.woff2
// module chunks = 1